import { render, staticRenderFns } from "./SeoBeginnerGuide.vue?vue&type=template&id=804d88ca&scoped=true"
import script from "./SeoBeginnerGuide.vue?vue&type=script&lang=js"
export * from "./SeoBeginnerGuide.vue?vue&type=script&lang=js"
import style0 from "./SeoBeginnerGuide.vue?vue&type=style&index=0&id=804d88ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804d88ca",
  null
  
)

export default component.exports